import useSession from "hooks/useSession";
import {
	LegalFooter,
	PTmbPassengers,
} from "libs/raas-ui-react-components/src/components";
import { getFooterLiterals } from "pages/private/AveFlow/AveFlow.util";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
	getLiteralsPagePassenger,
	getSecondaryTitleHolaBarcelona,
	getTmbPassengersModal,
	getTmbPassengerSeniorModal
} from "./TmbNormalFlow.util";
import { useNavigate } from "react-router-dom";
import {
	getIdTmbSelect,
	getTmbActivitySelected,
	initTMBSummaryDetail,
	setDataCodePromoSession,
	setOffSite,
	setTMBSummaryDetail,
} from "services/user/user.session.service";

export const TmbNormalFlow = () => {
	const { setProductTMBDetails } = useSession();
	const navigate = useNavigate();
	const [t] = useTranslation("tmbPages");
	const [t2] = useTranslation("aveFlow");
	const [t3] = useTranslation("tmbModals");

	const footerLiterals = getFooterLiterals(t2);
	const literalsPassengers = getLiteralsPagePassenger(t);

    let lenguage = "";

	const passengersInfo = () => {
		const selectedPassengers = initTMBSummaryDetail()?.passengers;
		return getTmbActivitySelected().price.map(
			(item: any, index: number) => {
                const passengerType = item.type;
                const passengerTypeUppercase = `${passengerType.charAt(0).toUpperCase()}${passengerType.slice(1)}`;
                
				return {
					id: item.type,
					passenger: passengerTypeUppercase,
					passPrice: item.gross,
					counter: 0,
					contextValue: item.contextValue,
					min: item.type === "Adultos" ? 1:0,
					max: 9,
					default: selectedPassengers?.passengers[index]?.counter,
                    isAdult: item.isAdult
				};
			},
		);
	};

    const getPassengersLiteralsModal = () => {
        if (getTmbActivitySelected().price.filter(
            (e: { isAdult: any; }) => e.isAdult).length > 1) {
        return getTmbPassengerSeniorModal(t3);
    } 
        
    return getTmbPassengersModal(t3);   
    }


	const [dataForm, setDataForm] = useState({
		id: getIdTmbSelect(),
		title: getTmbActivitySelected().title,
		secondaryTitle: "",
		contextType: getTmbActivitySelected().contextType,
		provider: getTmbActivitySelected().provider,
		passengers: {
			passengers: [],
			totalCount: 0,
			totalPrice: 0,
		},
	});	

	useEffect(() => {
		if (sessionStorage.getItem("raas-language") !== lenguage) {
			lenguage = sessionStorage.getItem("raas-language") as any;
		}
	}, [t]);

	const saveData = (e: any) => {
		dataForm.passengers.passengers = e.value.passengers;
		dataForm.passengers.totalCount = e.value.totalCount;
		dataForm.passengers.totalPrice = e.value.totalPrice;
		
		switch (getIdTmbSelect()) {
		
			case "holabarcelona-travel-card":
				dataForm.secondaryTitle = getSecondaryTitleHolaBarcelona(
					getTmbActivitySelected().title,
					t,
				);
				break;
			case "montjuic-cable-car":
				dataForm.secondaryTitle = t("literalsTeleferico.roundTrip");
				break;
			case "barcelona-bus-turistic":
			case	"barcelona-bus-turist":
				dataForm.secondaryTitle = getSecondaryTitleHolaBarcelona(
					getTmbActivitySelected().title,
					t,
				);
				break;
			default:
				break;
		}

		setProductTMBDetails(dataForm);
		setTMBSummaryDetail(dataForm);

		setOffSite(false)
    	setDataCodePromoSession({ voucherCode: '',voucherAmount:0, discountType: 'DOCO', isValid: false, reset:false,totalPrice:'0,00 €',totalPriceToPay:'0,00 €' })
		navigate("/tmb-resume-route");
	};

	return (
		<>
			<div className="tmb-flow">
				<div className="tmb-flow_body">
					<div className="section-body">
						<div className="left-section">
							<PTmbPassengers
								literals={literalsPassengers}
								literalsModal={getPassengersLiteralsModal()}
								passengers={passengersInfo()}
								onSendDataEmit={(ev) => saveData(ev?.detail)}
								onGoBackEmit={() => {
									navigate("/detail-activy");
								}}
							></PTmbPassengers>
						</div>
						<div className="rigth-section"></div>
					</div>
					<div className="section">
						<div className="mt-80">
							<LegalFooter
								literals={footerLiterals}
							></LegalFooter>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
